/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Messaging_Bots_Tlm_3Inputs */

const en_svc_messaging_bots_tlm_3 = /** @type {(inputs: Svc_Messaging_Bots_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sending_policy`)
};

const ar_svc_messaging_bots_tlm_3 = /** @type {(inputs: Svc_Messaging_Bots_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سياسة الإرسال`)
};

const bn_svc_messaging_bots_tlm_3 = /** @type {(inputs: Svc_Messaging_Bots_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পাঠানোর নীতি`)
};

const de_svc_messaging_bots_tlm_3 = /** @type {(inputs: Svc_Messaging_Bots_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senderichtlinie`)
};

const es_svc_messaging_bots_tlm_3 = /** @type {(inputs: Svc_Messaging_Bots_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de envío`)
};

const fr_svc_messaging_bots_tlm_3 = /** @type {(inputs: Svc_Messaging_Bots_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politique d'envoi`)
};

const pt_svc_messaging_bots_tlm_3 = /** @type {(inputs: Svc_Messaging_Bots_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de envio`)
};

const zh_svc_messaging_bots_tlm_3 = /** @type {(inputs: Svc_Messaging_Bots_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发送策略`)
};

const tr_svc_messaging_bots_tlm_3 = /** @type {(inputs: Svc_Messaging_Bots_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gönderim politikası`)
};

const ru_svc_messaging_bots_tlm_3 = /** @type {(inputs: Svc_Messaging_Bots_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Политика отправки`)
};

const pl_svc_messaging_bots_tlm_3 = /** @type {(inputs: Svc_Messaging_Bots_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polityka wysyłki`)
};

/**
* | output |
* | --- |
* | "sending_policy" |
*
* @param {Svc_Messaging_Bots_Tlm_3Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_messaging_bots_tlm_3 = /** @type {((inputs?: Svc_Messaging_Bots_Tlm_3Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Messaging_Bots_Tlm_3Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_messaging_bots_tlm_3(inputs)
	if (locale === "bn") return bn_svc_messaging_bots_tlm_3(inputs)
	if (locale === "de") return de_svc_messaging_bots_tlm_3(inputs)
	if (locale === "es") return es_svc_messaging_bots_tlm_3(inputs)
	if (locale === "fr") return fr_svc_messaging_bots_tlm_3(inputs)
	if (locale === "pt") return pt_svc_messaging_bots_tlm_3(inputs)
	if (locale === "zh") return zh_svc_messaging_bots_tlm_3(inputs)
	if (locale === "tr") return tr_svc_messaging_bots_tlm_3(inputs)
	if (locale === "ru") return ru_svc_messaging_bots_tlm_3(inputs)
	if (locale === "pl") return pl_svc_messaging_bots_tlm_3(inputs)
	return en_svc_messaging_bots_tlm_3(inputs)
});
export { svc_messaging_bots_tlm_3 as "svc_messaging-bots_tlm_3" }